<template>
  <div :class="$style.Container">
    <div :class="$style.Money"
      >支付金额：<span :class="$style.Price">￥{{ price || '...' }}</span
      ><span :class="$style.OriginPrice">￥{{ originPrice }}</span></div
    >
    <Button :class="$style.PayButton" @click="handlePay" :loading="paying">{{
      getOrderEnv() ? '立即付款' : '请使用微信/支付宝打开后，进行支付'
    }}</Button>
  </div>
</template>

<script lang="ts" setup>
  import { watch, onUnmounted, ref } from 'vue';
  import { useMobilePay } from '../paymemt-modal/hooks/useMobilePay';
  import { Button, message } from 'ant-design-vue';
  import { getApi } from '../init';

  const props = defineProps({
    agree: {
      type: Boolean,
      default: false,
    },

    skuId: {
      type: String,
      default: null,
    },

    originPrice: {
      type: String,
      default: null,
    },

    channel: {
      type: String,
      required: true,
    },

    wxConfig: {
      type: Object,
      required: true,
    },

    zfbConfig: {
      type: Object,
      required: true,
    },
  });

  const emits = defineEmits(['success']);

  const { pay, getOrderEnv } = useMobilePay();
  const price = ref();
  let isEndPolling = false;

  function startPolling(payCode: string) {
    isEndPolling = false;
    polling(payCode);
  }
  function endPolling() {
    isEndPolling = true;
  }

  // 获取价格
  async function getPrice() {
    const result = await getApi().aiadTransactionsApi.getMagicBeanSkuPrice({
      skuId: props.skuId,
    });
    price.value = result.price;
  }

  async function polling(payCode: string) {
    if (isEndPolling) return;

    const result = await getApi().tcQrCodeApi.getTransactionCode({
      code: payCode,
    });

    // 支付成功
    if (result.status === 'success') {
      emits('success', result);
      return;
    }

    setTimeout(() => {
      polling(payCode);
    }, 1000);
  }

  // 获取支付code
  const payCode = ref();
  async function getPayCode() {
    payCode.value = await getApi().tcQrCodeApi.transactionCode({
      skuId: props.skuId,
    });
  }

  // 点击立即支付
  const paying = ref(false);
  async function handlePay() {
    if (!getOrderEnv()) {
      message.warn('请使用微信/支付宝打开后，进行支付');
      return;
    }
    paying.value = true;

    try {
      await pay({
        // orderChannel: props.channel,
        payCode: payCode.value,
        wxConfig: props.wxConfig,
        zfbConfig: props.zfbConfig,
      });
    } finally {
      setTimeout(() => {
        paying.value = false;
      }, 1000);
    }
  }

  watch(
    () => props.skuId,
    async (v) => {
      if (v) {
        await Promise.all([getPrice(), getPayCode()]);
        startPolling(payCode.value);
      }
    },
    {
      immediate: true,
    },
  );

  onUnmounted(() => {
    endPolling();
  });
</script>

<style lang="less" module>
  .Container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 16px;
  }

  .PayButton {
    background: linear-gradient(94.36deg, #dc8647 0%, #c75241 99.73%) !important;
    width: 100%;
    height: 48px !important;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    display: flex !important;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.85) !important;
    opacity: 1 !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    margin-top: 8px;
  }

  .Money {
    display: flex;
    align-items: center;
    font-family: PingFang SC;
    font-weight: 400;
    font-style: Regular;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 22px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: rgba(255, 255, 255, 0.85);
  }

  .Price {
    font-family: PingFang SC;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    color: rgba(209, 108, 68, 1);
    margin-left: 4px;
  }

  .OriginPrice {
    font-family: PingFang SC;
    font-weight: 400;
    font-style: Regular;
    font-size: 13px;
    leading-trim: NONE;
    line-height: 22px;
    letter-spacing: 0%;
    vertical-align: middle;
    text-decoration: line-through;
    color: rgba(255, 255, 255, 0.45);
    margin-left: 4px;
  }
</style>
